var _defs, _circle, _circle2, _circle3, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntegrity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 54.5,
    transform: "rotate(-180 53.5 54.5)",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74",
    r: 21.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 54,
    transform: "rotate(90 23 54)",
    stroke: "#050505",
    r: 22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    transform: "rotate(90 23 23)",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74",
    r: 22
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5,
    cy: 23,
    rx: 22,
    ry: 21.5,
    transform: "rotate(90 54.5 23)",
    stroke: "#050505"
  })));
}

var MemoSvgIntegrity = /*#__PURE__*/React.memo(SvgIntegrity);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzciIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA3NyA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjUzLjUiIGN5PSI1NC41IiByeD0iMjEuNSIgcnk9IjIxLjUiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgNTMuNSA1NC41KSIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtZGFzaGFycmF5PSIyLjc0IDIuNzQiLz4KPGVsbGlwc2UgY3g9IjIzIiBjeT0iNTQiIHJ4PSIyMiIgcnk9IjIyIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAyMyA1NCkiIHN0cm9rZT0iIzA1MDUwNSIvPgo8ZWxsaXBzZSBjeD0iMjMiIGN5PSIyMyIgcng9IjIyIiByeT0iMjIiIHRyYW5zZm9ybT0icm90YXRlKDkwIDIzIDIzKSIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtZGFzaGFycmF5PSIyLjc0IDIuNzQiLz4KPGVsbGlwc2UgY3g9IjU0LjUiIGN5PSIyMyIgcng9IjIyIiByeT0iMjEuNSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNTQuNSAyMykiIHN0cm9rZT0iIzA1MDUwNSIvPgo8L3N2Zz4K";
export { MemoSvgIntegrity as ReactComponent };